module.exports = require('./../dist/src/system/dist/components/FormFieldSpinnerUp.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-icons-common/system/FormFieldSpinnerUp.js
// module id = 1334
// module chunks = 0